export const CHAT_BOTTOM_THRESHOLD = 50;
